// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_37zbH","content":"index_content_3m6WE","flag":"index_flag_2lGFM"};